"use client";

import { IPAGEEmpresa } from "@/services/types";
import Image
    from "next/image";
import RenderHtmlContentDescritpions from "../common/RenderHtmlContentDescritpions";
import { Card, CardContent, CardHeader } from "@/components/atoms/card";
import { ItemDescSection } from "../common/ItemDescSection";
interface PageProps {
    pageData: IPAGEEmpresa;
}
export default function EmpresaPageClient({ pageData }: PageProps) {

    return (

        <div>
            {/** image + description */}
            <section className="py-12 md:py-16 lg:py-24">
                <div className="container mx-auto px-4 md:px-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-start">
                        <div
                            className="rich-content w-full  pr-4 order-2 lg:order-1"
                            dangerouslySetInnerHTML={{ __html: pageData.description }}
                        />

                        <div className="w-full order-1 lg:order-2">
                            {pageData.image && pageData.image.url &&
                                <Image
                                    src={pageData.image.url}
                                    alt={pageData.image.alternativeText || 'Imagem'}
                                    className="rounded-2xl w-full h-auto"
                                    width={712}
                                    height={542}
                                />
                            }
                        </div>
                    </div>
                </div>
            </section>

            {/** session missao + valores objectivos */}
            <section className="relative py-6 md:py-8 lg:mb-24 xl:-mt-44 z-20">
                <div className="container mx-auto px-4 md:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
                        {
                            pageData.session_missao &&
                            pageData.session_missao.map((missao, index) => {
                                const colors = ['#82B662', '#EA5644', '#377396'];
                                const titleColor = colors[index % colors.length];
                                
                                return (
                                    <Card key={index} className="relative p-8 z-10 bg-white">
                                        <CardHeader className={`font-semibold text-2xl font-rubik px-0 py-2`} style={{ color: titleColor }}>
                                            {missao.title}
                                        </CardHeader>
                                        <CardContent className={"font-poppins text-base font-normal "}>
                                            <RenderHtmlContentDescritpions htmlContent={missao.description}></RenderHtmlContentDescritpions>
                                        </CardContent>
                                    </Card>
                                );
                            })
                        }
                    </div>
                </div>
            </section>

            {/** session objectivos*/}
            <section className="py-8 md:py-8 bg-white lg:mb-24">
                <div className="container mx-auto px-4 md:px-8">
                    <ItemDescSection itemData={pageData.session_objetivo} hasborder={false} />
                </div>
            </section>
        </div>
    );

}